
import { DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PolicyFormContainer } from "../../form/components/PolicyFormContainer";
import { LeadSourceType } from "@/types/leadSource";
import { ScrollArea } from "@/components/ui/scroll-area";

interface PolicyDialogContentProps {
  userId: string;
  producer: string;
  policyType: string;
  insuranceCarrier: string;
  policyLine: string;
  policyNumber: string;
  startDate: Date;
  endDate: Date;
  premiumAmount: number;
  status: string;
  leadSource: LeadSourceType;
  policyAcquisitionType: string;
  onProducerChange: (value: string) => void;
  onPolicyTypeChange: (value: string) => void;
  onInsuranceCarrierChange: (value: string) => void;
  onPolicyLineChange: (value: string) => void;
  onPolicyNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStartDateChange: (date?: Date) => void;
  onEndDateChange: (date?: Date) => void;
  onPremiumAmountChange: (value: number) => void;
  onStatusChange: (value: string) => void;
  onLeadSourceChange: (value: LeadSourceType) => void;
  onPolicyAcquisitionTypeChange: (value: string) => void;
  onSalesDateChange: (date: Date) => void;
  onSubmit: () => void;
  onCancel: () => void;
  clientName?: string;
  isSubmitting?: boolean;
  isFormValid?: boolean;
}

export const PolicyDialogContent = ({ 
  userId,
  producer,
  policyType,
  insuranceCarrier,
  policyLine,
  policyNumber,
  startDate,
  endDate,
  premiumAmount,
  status,
  leadSource,
  policyAcquisitionType,
  onProducerChange,
  onPolicyTypeChange,
  onInsuranceCarrierChange,
  onPolicyLineChange,
  onPolicyNumberChange,
  onStartDateChange,
  onEndDateChange,
  onPremiumAmountChange,
  onStatusChange,
  onLeadSourceChange,
  onPolicyAcquisitionTypeChange,
  onSalesDateChange,
  onSubmit,
  onCancel,
  clientName,
  isSubmitting = false,
  isFormValid = false
}: PolicyDialogContentProps) => {
  return (
    <DialogContent className="sm:max-w-[600px]">
      <DialogHeader>
        <DialogTitle>Create Policy {clientName ? `for ${clientName}` : ''}</DialogTitle>
      </DialogHeader>
      <ScrollArea className="max-h-[70vh]">
        <div className="py-4 pr-4">
          <PolicyFormContainer
            producer={producer}
            policyType={policyType}
            insuranceCarrier={insuranceCarrier}
            policyLine={policyLine}
            policyNumber={policyNumber}
            startDate={startDate}
            endDate={endDate}
            premiumAmount={premiumAmount}
            status={status}
            leadSource={leadSource}
            policyAcquisitionType={policyAcquisitionType}
            onProducerChange={onProducerChange}
            onPolicyTypeChange={onPolicyTypeChange}
            onInsuranceCarrierChange={onInsuranceCarrierChange}
            onPolicyLineChange={onPolicyLineChange}
            onPolicyNumberChange={onPolicyNumberChange}
            onStartDateChange={onStartDateChange}
            onEndDateChange={onEndDateChange}
            onPremiumAmountChange={onPremiumAmountChange}
            onStatusChange={onStatusChange}
            onLeadSourceChange={onLeadSourceChange}
            onPolicyAcquisitionTypeChange={onPolicyAcquisitionTypeChange}
            onSalesDateChange={onSalesDateChange}
            onSubmit={onSubmit}
            isSubmitDisabled={!isFormValid}
            onCancel={onCancel}
            submitLabel="Create Policy"
            isSubmitting={isSubmitting}
          />
        </div>
      </ScrollArea>
    </DialogContent>
  );
};
